export const storeModule = {
  address: "Store address",
  baseInfo: "Basic information",
  content: "Content",
  time: "Opening hours",
  dateTime: "Business day",
  pickTime: "Pickup time",
  devTime: "Take-away time",
  payFun: "Payment method",
  detail: "Shop details",
  detailInfo: "店铺详细",
  devPrice: "Delivery cost",
  minPrice: "Minimum order amount for delivery",
  freePrice: "Free delivery above *",
  freeDevPriceDiff: "あと*で無料配達！",
  freeDevPrice: "免配送费",
  leal: "Commercial law",
  lealTab1: "Project",
  lealTab2: "Included in the bar",
  lealTitle1: "Merchant name (company name, trade name or store name)",
  lealTitle2: "Merchant’s address",
  lealTitle3: "Representative or operation responsible person",
  lealTitle4: "Representative or operation responsible person (alias)",
  lealTitle5: "Contact address/official website",
  lealTitle6: "Contact address/e-mail",
  lealTitle7: "Contact address/tel.",
  lealTitle8: "Commodity price range",
  lealTitle9: "Delivery time, delivery method",
  lealTitle10: "Payment time and payment method",
  lealTitle11:
    "Necessary cost/delivery cost, service charge and consumption tax, etc. except commodity price",
  lealTitle12:
    "Condition(s) for goods return/return period, delivery cost caused by goods return or condition(s) for midway termination or membership withdrawal",
  lealTitle13: "Defective item processing method",
  shopTimeOuter1: "Close up shop",
  shopTimeOuter2: "Outside business hours",
  shopTimeOuterSm1: "Closed",
  shopTimeOuterSm2: "Closed",
  orderSm1: "Bookable",
  orderDayBefore: "* days ago",
  noText: "No",
  storeRemark: "Store notes",
  devDistanceNo: "目前的配送地址不在店铺配送范围内。请选择其他店铺",
  devSearch: "搜索",
  devNoAddress: "下記の三つから選択して下さい"
};
export const evaluationModule = {
  star: "Degree of satisfaction",
  contentHolder: "Please write down your evaluatio",
  noStar: "Please select degree of satisfaction",
  noContent: "Comment content cannot be empty",
  submitSuccess: "Successfully commented",
  replay: "Merchant reply",
  uploadSuccess: "Successfully upload"
};
